import localStorageEffect from '@/utils/recoil/localStorageEffect';
import { atom } from 'recoil';

import { BillBarBreadcrumb } from './types';

export const registeredBreadcrumbsState = atom<BillBarBreadcrumb[]>({
  key: 'billbar-registeredBreadcrumbs',
  default: [],
});

export const billbarVisibilityState = atom<boolean>({
  key: 'billbar-visibility-state',
  default: true,
  effects: [localStorageEffect('billbar-visibility')],
});
